import { useEffect } from 'react';
import { acquireScrollLock, releaseScrollLock } from '@/lib/scrollLock';

/**
 * active が true の間、背景（html / body）のスクロールをロックする。
 *
 * 実際のロックは参照カウント式の共通マネージャ（`@/lib/scrollLock`）に委ねる。
 * これにより複数のオーバーレイ／メニューのロックが重なっても、解除の順番に依存せず
 * 最後にすべて解放されたときだけ元の状態へ戻るため、
 * 「ログアウト→再ログイン後にスクロールできなくなる」不具合を防げる。
 *
 * このアプリは横スクロール対策で `html` に `overflow-x: clip` を当てているため、
 * body だけでなく html もロックする（マネージャ側で両方扱う）。
 */
export function useScrollLock(active: boolean) {
  useEffect(() => {
    if (!active) return;
    acquireScrollLock();
    return () => releaseScrollLock();
  }, [active]);
}